import { Navigate, Outlet } from "react-router-dom";

export const ProtectedRoute = () => {
  const token = localStorage.getItem("admin_token");
  const loginTimestamp = localStorage.getItem("admin_login_timestamp");

  if (!token) {
    return <Navigate to="/admin-panel/login" replace />;
  }

  // 24 Hour Timeout Check
  if (loginTimestamp) {
      const isExpired = Date.now() - parseInt(loginTimestamp) > 24 * 60 * 60 * 1000;
      if (isExpired) {
          localStorage.removeItem("admin_token");
          localStorage.removeItem("admin_login_timestamp");
          localStorage.removeItem("username");
          localStorage.removeItem("is_superuser");
          localStorage.removeItem("admin_profile_image");
          return <Navigate to="/admin-panel/login" replace />;
      }
  }

  return <Outlet />;
};
